import { createContext, useEffect, useState } from "react";

function PAGE_GET_current() {
    const loc = window.location; // http://test/loc
    var pathname = loc.pathname; // /loc

    if (pathname === ('/')) {
        return '';
    }

    if (pathname.endsWith('/')) {
        pathname = pathname.substring(0, pathname.length - 1);
    }

    return pathname.substring(1);
}
function PAGE_GET_URL(page) {
    const loc = window.location;
    const host = loc.host;
    const protocol = loc.protocol;
    const origin = loc.origin;

    return origin + '/' + page;
}

function PAGE_SET_current(page, reload, skipHistory) {
    const url = PAGE_GET_URL(page);
    if (reload) {
        window.location.href = url;
        return url;
    }
    if (!skipHistory) {
        window.history.pushState(null, page, url)
    }
    return url;
}

export const PageContext = createContext();
export function PageRouter(props) {
    const { query } = props;
    const [page, setPage] = useState(PAGE_GET_current());

    function updatePage(page, skipHistory) {
        var q = ''
        if (query) {
            q = '?'
            Object.entries(query).forEach((values) => {
                q += values[0] + '=' + values[1] + "&"
            })
        }
        setPage(page);
        PAGE_SET_current(page + q, skipHistory)
        window.scrollTo(0, 0);
    }

    useEffect(() => {
        window.onpopstate = () => {
            setPage(PAGE_GET_current());
        }
    }, [])

    const path = page.split('/')

    // ----------------------------------

    return <PageContext.Provider value={{
        setPage: updatePage,
        path: path,
        page: page,
    }}>
        {props.children}
    </PageContext.Provider>


}